import React, { useState } from "react";
import { message, Form, Input, Select, Row, Col, Button } from "antd";
import { useListVals } from "../../Firebase/databaseHooks";
import { getDatabase, ref, set } from "firebase/database";
import { v4 as uuidv4 } from 'uuid';
import moment from "moment";
import Firebase from "../../Firebase/Firebase";
import { useAuth } from "../../AuthContext/AuthContext";

const db = getDatabase(Firebase);

const DuplicateLesson = ({ id, snapshot, onDuplicateComplete, onCancel }) => {
  const { canAccessModule } = useAuth();
  const canCreateLesson = canAccessModule("LESSONS", "create");
  const [form] = Form.useForm();
  const [duplicating, setDuplicating] = useState(false);
  const [languagesArray] = useListVals(ref(db, "talmidsdb/languages"));

  const handleFinish = async (values) => {
    if (!canCreateLesson) {
      message.error("You do not have permission to create lessons.");
      return;
    }

    setDuplicating(true);
    try {
      if (!snapshot || !snapshot.exists()) {
        throw new Error("Lesson not found");
      }

      const originalLesson = snapshot.val();
      const timeStamp = moment().format("YYYY-MM-DDTh:mm:ss");
      const newLessonId = uuidv4();

      const newLesson = {
        ...originalLesson,
        lessonName: values.lessonName,
        lessonCode: values.lessonCode,
        language: values.language,
        dateAdded: timeStamp,
        id: newLessonId,
        lessonStatus: "draft"
      };

      await set(ref(db, `talmidsdb/lessons/${newLessonId}`), newLesson);

      message.success("Lesson duplicated successfully");

      if (onDuplicateComplete) {
        onDuplicateComplete(newLessonId);
      }
    } catch (error) {
      console.error("Failed to duplicate lesson:", error);
      message.error("Failed to duplicate lesson");
    } finally {
      setDuplicating(false);
    }
  };

  const initialValues = {
    language: "",
    lessonName: "",
    lessonCode: ''
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleFinish}
      initialValues={initialValues}
    >
      <Row gutter={8} align="bottom">
        <Col span={24}>
          <Form.Item
            label="Language"
            name="language"
            rules={[{ required: true, message: 'Please select a language' }]}
          >
            <Select placeholder="Select language">
              {languagesArray?.map((lang) => (
                <Select.Option key={lang.id} value={lang.id}>
                  {lang.languageName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label="Lesson Name"
            name="lessonName"
            rules={[{ required: true, message: 'Please enter a lesson name' }]}
          >
            <Input placeholder="Enter lesson name" />
          </Form.Item>
          <Form.Item
            label="Lesson Code"
            name="lessonCode"
            rules={[{ required: true, message: 'Please enter a lesson code' }]}
          >
            <Input placeholder="Enter lesson code" />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item style={{ marginBottom: '1.5rem' }}>
            <Button
              type="primary"
              htmlType="submit"
              loading={duplicating}
              disabled={!canCreateLesson}
              style={{ width: '100%', backgroundColor: "#51195D" }}
            >
              Duplicate
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default React.memo(DuplicateLesson);
